import { callable } from './callable.js'

export type MediaConsentLevel = 'PHOTOS_OK' | 'CLASS_ONLY' | 'NONE'

export interface ListEduMediaConsentsInput {
  workspaceId: string
  nodeId: string
}

export interface LearnerMediaConsentItem {
  learnerId: string
  displayName: string
  level: MediaConsentLevel
  setBy?: string | null
  setAt?: unknown | null
}

export interface ListEduMediaConsentsResult {
  consents: LearnerMediaConsentItem[]
}

export interface EduMediaConsent {
  workspaceId: string
  learnerId: string
  level: MediaConsentLevel
  setBy: string | null
  setByName?: string | null
  setAt: string | null
}

export interface SetEduMediaConsentInput {
  workspaceId: string
  learnerId: string
  level: MediaConsentLevel
}

export interface SetEduMediaConsentResult {
  success: boolean
  level: MediaConsentLevel
  consent: EduMediaConsent
}

export interface GetEduMediaConsentInput {
  workspaceId: string
  learnerId: string
}

export interface GetEduMediaConsentResult {
  consent: EduMediaConsent
}

export async function listEduMediaConsents(
  input: ListEduMediaConsentsInput,
): Promise<ListEduMediaConsentsResult> {
  return callable('listEduMediaConsents', input)
}

export async function getEduMediaConsent(
  input: GetEduMediaConsentInput,
): Promise<GetEduMediaConsentResult> {
  return callable('getEduMediaConsent', input)
}

export async function setEduMediaConsent(
  input: SetEduMediaConsentInput,
): Promise<SetEduMediaConsentResult> {
  return callable('setEduMediaConsent', input)
}

